import React from 'react';
import EventsList from './components/EventsList';

function App() {
  return (
    <div>
      <EventsList />
    </div>
  );
}

export default App;